import useSWR from "swr";

import { type DocumentHistoryResponse } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/documents";

export function useDocumentHistory(id: string | number | undefined) {
  return useSWR<DocumentHistoryResponse, Error>(
    id ? `${url}/${id}/history` : null,
    simpleFetcher,
  );
}
